import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { DateTime } from 'luxon';
import { Taetigkeit } from '../../../semantics/Taetigkeit.js';
import type { Vertragsarten } from './Mitarbeiter.js';

/**
 * @entity CRVertrag
 */
@Entity()
export class CRVertrag extends AdornisEntity {
  public static override _class = 'CRVertrag';

  @Field(() => ID, { default: v => v ?? A.getGloballyUniqueID() })
  public _id!: string;

  @Field(() => DateTime, { default: v => v ?? DateTime.now() })
  public startDatum: Maybe<DateTime>;

  @Field(() => String)
  public vertragsart: Maybe<Vertragsarten>;

  @Field(() => [String], { default: v => v ?? [] })
  public taetigkeitenIDs: Maybe<string[]>;

  @DataLoadedField(() => [Taetigkeit], ({ taetigkeitenIDs }) => taetigkeitenIDs ?? [])
  public taetigkeiten: Maybe<Taetigkeit[]>;
}
